import { HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, of, Subject } from 'rxjs';
import { API_BASE_URL_SERVICE } from '../../kiene-core.config';
import { KieneBackendApiService } from '../../services/backend-api/kiene-backend-api.service';
import { LocalStorageService } from '../../services/local-storage/local-storage.service';
import { PosthogService } from '../../services/posthog/posthog.service';
import { Hilfe, HilfeBackend, HilfeDialogInput, HilfeDialogResult } from './Hilfe';
import { HilfeDialogComponent } from './hilfe-dialog/hilfe-dialog.component';

@Injectable({ providedIn: 'root' })
export class HilfeService {
    constructor(
        private localStorageService: LocalStorageService,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private api: KieneBackendApiService,
        private dialog: MatDialog,
        private posthog: PosthogService,
    ) {}

    getHelpAvailable(gesamteUrl: string, projekt: string): Observable<any> {
        if (!this.localStorageService.isLoggedIn() || !gesamteUrl) {
            return of(null);
        }

        const url = Hilfe.urlAufbereiten(gesamteUrl);
        if (!url || url === '/') {
            return of(null);
        }

        const params = new HttpParams().set('route_url', url).set('projekt', projekt);
        return this.api.getAll(this.apiBaseUrl + 'hilfe/search.php', params);
    }

    openHilfeDialog(hilfe: Hilfe): Observable<HilfeDialogResult> {
        const subject = new Subject<HilfeDialogResult>();

        this.posthog.capture('help_opened', {
            route: Hilfe.urlAufbereiten(hilfe?.route_url || ''),
            has_help: !!hilfe?.hilfe_id,
            projekt: hilfe?.projekt || '',
        });

        // const width = hilfe?.projekt === 'desktop' ? '70%' : '98%';
        const width = '100%';
        const height = '95%';

        const input = new HilfeDialogInput(hilfe);

        this.dialog
            .open(HilfeDialogComponent, { data: input, width: width, height: height, minWidth: '100vw' })
            .afterClosed()
            .subscribe({
                next: (hilfeResult: HilfeDialogResult) => {
                    subject.next(hilfeResult);
                },
            });

        return subject;
    }

    /**
     * Bereitet die Hilfe-Daten vor, indem Frontend-spezifische Eigenschaften entfernt werden.
     * @param hilfe Die Hilfe-Daten mit Frontend-Eigenschaften.
     * @returns Die bereinigten Hilfe-Daten für das Backend.
     */
    prepareHilfeForBackend(hilfe: Hilfe): HilfeBackend {
        return {
            hilfe_id: hilfe.hilfe_id,
            route_url: hilfe.route_url,
            projekt: hilfe.projekt,
            hilfe_reiter: hilfe.hilfe_reiter.map(reiter => ({
                titel: reiter.titel,
                hilfeseite_url: reiter.hilfeseite_url,
                benutzerrollen: reiter.benutzerrollen,
            })),
        };
    }

    /**
     * Aktualisiert die Hilfe-Daten im Backend.
     * @param hilfe Die Hilfe-Daten mit Frontend-Eigenschaften.
     * @returns Ein Observable mit dem Ergebnis der Aktualisierung.
     */
    updateHilfe(hilfe: Hilfe): Observable<any> {
        const hilfeToSend: HilfeBackend = this.prepareHilfeForBackend(hilfe);
        return this.api.post(`${this.apiBaseUrl}hilfe/update.php`, hilfeToSend);
    }
}
